var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sceneFlyover } from "./utils/sceneFlyover";
import { DURATIONS, FOCUSES, POSITIONS } from "./utils/standardImageryFlyoverData";
import { defaultRendererConfig } from "./index";
export function bingImageryFlyover2(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Bing Imagery Flyover 2" +
                "</h1>" +
                "<p>" +
                "The camera will fly over the globe with a specific imagery source. The globe should render normally." +
                "</p>";
        yield sceneFlyover(defaultRendererConfig(container), DURATIONS, POSITIONS, FOCUSES, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Intentionally dropped promise, blocking is not needed
            const _ = renderer
                .getWorld()
                .getGlobe()
                .setTileLayers([
                {
                    type: "bing",
                    mapType: "aerialWithLabels",
                },
            ]);
        }));
    });
}
